export enum UserSourceFilter {
  ALL = 0,
  UPORTAL = 1,
  STROBBO = 2,
  SUPERPLANNER = 3,
  SHYFTER = 4,
}
